"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NO_UNITS = exports.PROPERTY_DATA_MIN_GIA = exports.MAX_MONTH_INPUT = exports.RESIDUAL_LAND_VALUE_MAX_ITERATIONS = void 0;
exports.RESIDUAL_LAND_VALUE_MAX_ITERATIONS = 100;
exports.MAX_MONTH_INPUT = 600;
exports.PROPERTY_DATA_MIN_GIA = 600;
exports.MAX_NO_UNITS = 100;
